import { render, staticRenderFns } from "./ExtensionSendButton.vue?vue&type=template&id=e8dc0bdc&scoped=true&"
import script from "./ExtensionSendButton.vue?vue&type=script&lang=js&"
export * from "./ExtensionSendButton.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionSendButton.vue?vue&type=style&index=0&id=e8dc0bdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dc0bdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
